import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

@Component({
    selector: 'gtw-credits-date-various',
    templateUrl: './credits-date-various.component.html',
    styleUrls: ['./credits-date-various.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CreditsDateVariousComponent {
  @Input() row: any = {};
  @Output() changed = new EventEmitter<any>();

  get isVarious(): boolean {
    return this.row?.ATTRIB_VALUE === 'VARIOUS';
  }

  toggleVarious(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    if (checked) {
      this.row.ATTRIB_VALUE = 'VARIOUS';
    } else {
      // Clear the field so the user can pick a fresh date instead of being
      // stuck with the previous value or today's date.
      this.row.ATTRIB_VALUE = '';
    }
    this.row.IS_CHANGED_FLAG = 'Y';
    this.changed.emit(this.row);
  }

  onDateSelected(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    if (value) {
      this.row.ATTRIB_VALUE = new Date(value + 'T00:00:00');
    } else {
      this.row.ATTRIB_VALUE = '';
    }
    this.row.IS_CHANGED_FLAG = 'Y';
    this.changed.emit(this.row);
  }

  formatDateForInput(val: any): string {
    if (!val || val === 'VARIOUS') return '';
    try {
      const d = (val instanceof Date) ? val : new Date(val);
      if (isNaN(d.getTime())) return '';
      const month = ('0' + (d.getMonth() + 1)).slice(-2);
      const day = ('0' + d.getDate()).slice(-2);
      const year = d.getFullYear();
      return `${year}-${month}-${day}`;
    } catch (e) {
      return '';
    }
  }
}
